export const menuToggleMetaData = {
    mobileOnly: true
}
